exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.shortcut p[data-v-62ba5f37] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n", "", {"version":3,"sources":["D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/home/D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/home/shortcut.vue"],"names":[],"mappings":";AA0HA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;CACA","file":"shortcut.vue?vue&type=style&index=0&id=62ba5f37&prod&scoped=true&lang=css&","sourcesContent":["\n.shortcut p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);

// exports
